import 'slick-carousel/slick/slick-theme.css';

function carouselCallback(e) {
    const children = e.target.querySelectorAll('.slick-active');
    if (children.length > 0) {
        children[children.length - 1].querySelector('a').click();
    }
}

function historyFilter(era) {
    if (!era.textContent || era.textContent.length === 0) {
        return;
    }
    const years = [];
    for (const item of document.querySelectorAll('#eras .slick-active .era-item')) {
        years.push(parseInt(item.textContent.trim()));
    }
    const historyContents = document.getElementById('history-contents');
    const items = historyContents.querySelectorAll('.history-item');
    for (const item of items) {
        if (years.indexOf(parseInt(item.dataset.year)) === -1) {
            item.style.display = 'none';
        } else {
            item.style.display = '';
        }
    }

}

const eraTab = document.getElementById('eras');
$(eraTab).slick({
    slidesToShow: 8,
    slidesToScroll: 8,
    responsive: [
        {
            breakpoint: 1024,
            settings: {
                slidesToShow: 8,
                slidesToScroll: 8,
            }
        },
        {
            breakpoint: 600,
            settings: {
                slidesToShow: 4,
                slidesToScroll: 4,
            }
        },
        {
            breakpoint: 480,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 3,
            }
        },
    ]
});
$(eraTab).on('afterChange', function(event, slick, currentSlide, nextSlide){
    carouselCallback(event);
});

const eras = document.querySelectorAll('.era-item > a');
if (eras.length) {
    for (const era of eras) {
        era.addEventListener('click', e => {
            historyFilter(era);
        });
    }
    historyFilter(eras[0]);
}
